module.exports = __webpack_public_path__ + "static/media/home.b8c9b85a.svg";